import { render, staticRenderFns } from "./bandwechat.vue?vue&type=template&id=39ee479c&scoped=true"
import script from "./bandwechat.vue?vue&type=script&lang=js"
export * from "./bandwechat.vue?vue&type=script&lang=js"
import style0 from "./bandwechat.vue?vue&type=style&index=0&id=39ee479c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee479c",
  null
  
)

export default component.exports